import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiFetch, apiSearch } from '../modules/utility';

const apiBase = 'requiredPtoRequest';
const myListName = 'myRequiredPtoRequests';
const allListName = 'allRequiredPtoRequests';

const myIdsField = 'myRequiredPtoRequestIds';
const allIdsField = 'allRequiredPtoRequestIds';

//const listName = `${apiBase}s`;
const idField = `${apiBase}Id`;

const search = (p = {}) => {
	const { params, callback = _.noop } = p;

	const { searchFor } = params;
	let listName = searchFor === 'myRequests' ? myIdsField : allIdsField;

	return (dispatch) => {
		apiSearch({
			base: apiBase,
			forceEmptySet: true,
			listName,
			params,
			dispatch,
			callback,
		});
	};
};

const get = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapStateToProps = (state, ownProps) => {
	const newState = {};

	const userId = ownProps[idField]
		? ownProps[idField]
		: _.get(ownProps, ['match', 'params', idField]);

	newState[apiBase] = _.get(state.maps, [apiBase, userId]);

	newState[myListName] = undefined;
	newState[allListName] = undefined;
	if (state.lists[myIdsField]) {
		newState[myListName] = _.map(state.lists[myIdsField], (id) => state.maps[apiBase][id]);
	}
	if (state.lists[allIdsField]) {
		newState[allListName] = _.map(state.lists[allIdsField], (id) => state.maps[apiBase][id]);
	}

	newState.userMap = state.maps.user;
	return newState;
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			searchRequiredPtoRequests: search,
			getRequiredPtoRequest: get,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
